var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLayersFeat = function SvgLayersFeat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.772 1.555a.5.5 0 0 1 .456 0l8 4.1a.5.5 0 0 1 0 .89l-8 4.101a.5.5 0 0 1-.456 0l-8-4.1a.5.5 0 0 1 0-.89l8-4.1ZM3.096 6.101 10 9.639l6.904-3.538L10 2.56 3.096 6.1Zm-1.54 3.65a.5.5 0 0 1 .672-.217L10 13.518l7.772-3.984a.5.5 0 0 1 .456.89l-8 4.1a.5.5 0 0 1-.456 0l-8-4.1a.5.5 0 0 1-.217-.673Zm0 3.92a.5.5 0 0 1 .672-.217L10 17.438l7.772-3.984a.5.5 0 0 1 .456.89l-8 4.101a.5.5 0 0 1-.456 0l-8-4.1a.5.5 0 0 1-.217-.674Z",
    clipRule: "evenodd"
  })));
};
export default SvgLayersFeat;